export function getLocale(locale, componentName, props = {}, defaultLocale = {}) {
    const { locale: componentLocale = {} } = props;
    try {
        delete props.locale;
    }
    catch (e) {
    }
    return Object.assign(Object.assign(Object.assign({}, defaultLocale), (locale[componentName] || {})), (componentLocale || {}));
}
